import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { LayoutStyle } from '../../../Common/PageBuilder/models/layout-style.model';
import { LayoutBlockDisplayRatiosEnum, layoutBlockDisplayRatiosToWidthPercentMap } from '../../../Common/PageBuilder/enums/layout-block-display-ratios.enum';


export class MonitoringLayoutStyle extends LayoutStyle {

    declare styleState: number | string;
    declare displayStyleState: number | string;

    constructor(apiModel?: any, displayRatio?: LayoutBlockDisplayRatiosEnum) {
        super(apiModel);
        if (apiModel) {
            if (!this.styleState || this.styleState === StyleStateEnum.DEFAULT) {
                this.styleState = BriefingStyleStateEnum.BRIEFING_1;
            }
            if (!this.displayStyleState || this.displayStyleState === StyleStateEnum.DEFAULT) {
                this.displayStyleState = this.styleState;
            }
            if (
                (
                    !this.defaultReference ||
                    this.defaultReference === StyleStateEnum.DEFAULT
                ) &&
                typeof this.styleState === 'string'
            ) {
                // Legacy data may not have default reference set, if the styleState is custom and there's no default reference, the default reference
                // should be BRIEFING_1 because it must have been created back when there was only one default
                this.defaultReference = this.styleState !== StyleStateEnum.CUSTOM ? this.styleState as string : BriefingStyleStateEnum.BRIEFING_1;
            }
        } else {
            if (!this.displayRatio) {
                this.displayRatio = displayRatio;
                this.width = layoutBlockDisplayRatiosToWidthPercentMap.get(displayRatio);
            }
        }
    }

    clone(): MonitoringLayoutStyle {
        const clone = super.clone();
        clone.defaultReference = this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1;

        return clone;
    }

    toApi(): any {
        const api = super.toApi();
        api.defaultReference = this.defaultReference ? this.defaultReference : BriefingStyleStateEnum.BRIEFING_1;

        return api;
    }
}
